import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import sortItems, { sortFloorPlans } from 'helpers/sortItems'
import { updateUiAction } from 'actions/uiActions'
import { changeCameraAction } from 'actions/cameraActions'
import { zoomToSingleCameraAction } from 'actions/mapActions'
import { updateCurrentEntityAction } from 'actions/applicationActions'
import Panel from 'components/Panel'
import VideoPanel from 'components/VideoPanel'
import ViewOptionsPanel from 'components/ViewOptionsPanel'
import { labelsSelector } from 'selectors/components'
import { WIRED_DEVICE_TYPES } from 'helpers/globals'

const mapStateToProps = state => {
  const { cameras, currentEntity, map: { floorPlans, ref }, ui: { viewOptionsPanelOpen }, entities } = state

  return {
    cameras,
    currentEntity,
    floorPlans,
    viewOptionsPanelOpen,
    labels: labelsSelector(state),
    doorControllers: entities.doorControllers.byId,
    doors: entities.doors.byId,
    networkClosets: entities.networkClosets.byId,
    wiredDevices: entities.wiredDevices.byId,
    map: ref
  }
}

const isSelected = (currentEntity, type, camera) => {
  return currentEntity && currentEntity.type === type && currentEntity.id === camera.id
}

class ProjectItemList extends React.Component {
  cameraClickHandler = camera => {
    const { currentEntity, updateUiAction, changeCameraAction, zoomToSingleCameraAction, updateCurrentEntityAction } = this.props

    updateUiAction({ sidebarView: 'cameraDetails' })
    if (!camera.active) {
      changeCameraAction(camera.id)
      zoomToSingleCameraAction(camera)
    } else if (!isSelected(currentEntity, 'camera', camera)) {
      updateCurrentEntityAction({ id: camera.id, type: 'camera' })
      zoomToSingleCameraAction(camera)
    }
  }

  renderLenses = camera => {
    const { currentEntity, cameras, classes } = this.props
    const lenses = camera.lensIds.map(lensId => cameras.find(c => c.id === lensId))

    return (
      <div className={classes.lensWrapper}>
        { sortItems(lenses).map(lens => (
            <a onClick={_ => this.cameraClickHandler(lens)} key={'lens' + lens.id}>
              {lens.name} {isSelected(currentEntity, 'camera', lens) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
            </a>
          ))
        }
      </div>
    )
  }

  renderDoors = doorController => {
    const { map, updateUiAction, updateCurrentEntityAction, classes } = this.props
    const doors = doorController.doorIds.map(doorId => this.props.doors[doorId])

    return (
      <div className={classes.lensWrapper}>
        { doors.map(door => (
            <a
              onClick={_ => {
                updateUiAction({ sidebarView: 'doorDetails' })
                updateCurrentEntityAction({ id: door.id, type: 'door' })
                map.panTo(door.location)
              }}
              key={'door' + door.id}
            >
              {door.name} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
            </a>
          ))
        }
      </div>
    )
  }

  renderExpansions = doorController => {
    const { map, updateUiAction, updateCurrentEntityAction, classes } = this.props
    if (doorController.expansionIds.length === 0) return null

    const expansions = doorController.expansionIds.map(expansionId => this.props.doorControllers[expansionId])

    return (
      <div className={classes.lensWrapper}>
        { expansions.map(doorController => (
            <div key={'doorController' + doorController.id}>
              <a
                onClick={_ => {
                  updateUiAction({ sidebarView: 'doorControllerDetails' })
                  updateCurrentEntityAction({ id: doorController.id, type: 'doorController' })
                  map.panTo(doorController.location)
                }}
              >
                {doorController.name} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
              </a>
              {this.renderDoors(doorController)}
            </div>
          ))
        }
      </div>
    )
  }

  renderItemLists = _ => {
    const { cameraClickHandler, renderLenses, renderDoors, renderExpansions, props: { cameras, currentEntity, labels, floorPlans,
      updateUiAction, updateCurrentEntityAction, networkClosets, wiredDevices, doorControllers, map, classes } } = this

    if (!cameras.length && !labels.length && !floorPlans.length && !Object.keys(networkClosets).length && !Object.keys(wiredDevices).length && !Object.keys(doorControllers).length) {
      return (
        <div className={classes.container}>
          <span>Devices:</span>
          <p style={{ marginBottom: '0rem' }}><i>No devices yet</i></p>
        </div>
      )
    }

    return (
      <div>
        { cameras.length > 0 &&
          <div className={classes.container}>
            <span>Cameras:</span>
            { sortItems(cameras.filter(c => !c.imagerId)).map(function(camera, i) {
                return (
                  <div className={`${classes.item} ${isSelected(currentEntity, 'camera', camera) && classes.selected}`} key={i}>
                    <a onClick={_ => cameraClickHandler(camera)}>
                      {camera.name} {isSelected(currentEntity, 'camera', camera) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
                    </a>
                    { camera.isMultiImager && renderLenses(camera) }
                  </div>
                )
              })
            }
          </div>
        }
        { Object.keys(doorControllers).length > 0 &&
          <div className={classes.container}>
            <span>Door Controllers:</span>
            { sortItems(Object.values(doorControllers).filter(doorController => !doorController.isExpansion)).map(function(doorController, i) {
                const selected = isSelected(currentEntity, 'doorController', doorController)
                return (
                  <div className={`${classes.item} ${selected && classes.selected}`} key={i}>
                    <a
                      onClick={_ => {
                        updateUiAction({ sidebarView: 'doorControllerDetails' })
                        if (!selected) {
                          updateCurrentEntityAction({ id: doorController.id, type: 'doorController' })
                          map.panTo(doorController.location)
                        }
                      }}
                    >
                      { doorController.name } {selected ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
                    </a>
                    {renderDoors(doorController)}
                    {renderExpansions(doorController)}
                  </div>
                )
              })
            }
          </div>
        }
        { WIRED_DEVICE_TYPES.map(({ text, value }) => {
            const devices = Object.values(wiredDevices).filter(device => device.type === value)

            if (devices.length === 0) return null

            return (
              <div className={classes.container} key={value}>
                <span>{text}s:</span>
                { sortItems(devices).map(function(wiredDevice, i) {
                    return (
                      <div className={`${classes.item} ${isSelected(currentEntity, 'wiredDevice', wiredDevice) && classes.selected}`} key={i}>
                        <a
                          onClick={_ => {
                            updateUiAction({ sidebarView: 'wiredDeviceDetails' })
                            if (!isSelected(currentEntity, 'wiredDevice', wiredDevice)) {
                              updateCurrentEntityAction({ id: wiredDevice.id, type: 'wiredDevice' })
                              map.panTo(wiredDevice.location)
                            }
                          }}
                        >{ wiredDevice.name } {isSelected(currentEntity, 'wiredDevice', wiredDevice) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} /></a>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }
        { labels.length > 0 &&
          <div className={classes.container}>
            <span>Labels:</span>
            { sortItems(labels, 'text').map(function(label, i) {
                return (
                  <div className={`${classes.item} ${isSelected(currentEntity, 'label', label) && classes.selected}`} key={i}>
                    <a
                      onClick={_ => {
                        updateUiAction({ sidebarView: 'labelDetails' })
                        if (!isSelected(currentEntity, 'label', label)) {
                          updateCurrentEntityAction({ id: label.id, type: 'label' })
                          label.overlay.map.fitBounds(label.overlay.rectangle.getBounds())
                        }
                      }}
                    >{label.text} {isSelected(currentEntity, 'label', label) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} /></a>
                  </div>
                )
              })
            }
          </div>
        }
        { floorPlans.length > 0 &&
          <div className={classes.container}>
            <span>Floor Plans:</span>
            { sortFloorPlans(floorPlans).map(function(floorplan, i) {
                return (
                  <div className={`${classes.item} ${isSelected(currentEntity, 'floorPlan', floorplan) && classes.selected}`} key={i}>
                    <a
                      onClick={_ => {
                        updateUiAction({ sidebarView: 'floorPlanDetails' })
                        if (!isSelected(currentEntity, 'floorPlan', floorplan)) {
                          updateCurrentEntityAction({ id: floorplan.id, type: 'floorPlan' })
                          floorplan.overlay.map.fitBounds(floorplan.overlay.getBounds())
                        }
                      }}
                    >{ floorplan.name || `Floor Plan ${floorplan.id}` } {isSelected(currentEntity, 'floorPlan', floorplan) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} /></a>
                  </div>
                )
              })
            }
          </div>
        }
        { Object.keys(networkClosets).length > 0 &&
          <div className={classes.container}>
            <span>Network Closets:</span>
            { sortItems(Object.values(networkClosets)).map(function(networkCloset, i) {
                return (
                  <div className={`${classes.item} ${isSelected(currentEntity, 'networkCloset', networkCloset) && classes.selected}`} key={i}>
                    <a
                      onClick={_ => {
                        updateUiAction({ sidebarView: 'networkClosetDetails' })
                        if (!isSelected(currentEntity, 'networkCloset', networkCloset)) {
                          updateCurrentEntityAction({ id: networkCloset.id, type: 'networkCloset' })
                          map.panTo(networkCloset.location)
                        }
                      }}
                    >{ networkCloset.name } {isSelected(currentEntity, 'networkCloset', networkCloset) ? ' (selected)' : ''} <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} /></a>
                  </div>
                )
              })
            }
          </div>
        }
      </div>
    )
  }

  render() {
    const { renderItemLists, props: { viewOptionsPanelOpen, updateUiAction, classes } } = this

    return (
      <div className={classes.list}>
        <div className={classes.title}>All Project Items</div>
        { renderItemLists() }
        <div className={classes.spacer} />
        <Panel
          active={viewOptionsPanelOpen}
          component={<ViewOptionsPanel />}
          title='Project Options'
          updateUiAction={updateUiAction}
          uiKey='viewOptionsPanelOpen'
        />
        <VideoPanel
          videoUrl='https://www.youtube.com/embed/xpoUAlnYmCc?rel=0&showinfo=0'
          title='Help and Tutorial'
          uiKey='tutorialVideoPanelOpen'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, changeCameraAction, zoomToSingleCameraAction, updateCurrentEntityAction })(injectSheet(style)(ProjectItemList))



// WEBPACK FOOTER //
// ./src/components/ProjectItemList/index.js